export interface LandingAttributes {
    clid: string | undefined
    gameHru: string | undefined
    widgetId: string | undefined
}

export function parseLandingAttributes(value: string | undefined): LandingAttributes {
    if (!value) {
        return { clid: undefined, gameHru: undefined, widgetId: undefined }
    }
    const [clid, gameHru] = value.split(':')
    return { clid, gameHru, widgetId: value }
}

export function composeLandingAttributes(clid: string, gameHru: string = 'Main_page'): string {
    return `${clid}:${gameHru}`
}
